/** Rules for names, phones and powers of attorney (spec §6.8–6.9; v1 validators). */

const ALPHA_DASH = /^[\p{L}\p{N}_-]+$/u;

/** The server validates names as alpha_dash: no spaces, letters/digits/dash/underscore only. */
export function nameError(value: string, required: boolean): string | null {
  const v = value.trim();
  if (!v) return required ? 'Обязательное поле' : null;
  return ALPHA_DASH.test(v) ? null : 'Без пробелов: можно буквы, цифры, дефис';
}

/** Russian phone typed by hand → +7XXXXXXXXXX; null if it cannot be a phone (server needs ≥10 digits). */
export function normalizePhone(input: string): string | null {
  let digits = input.replace(/\D/g, '');
  if (digits.length === 11 && (digits.startsWith('8') || digits.startsWith('7'))) digits = digits.slice(1);
  if (digits.length !== 10) return null;
  return `+7${digits}`;
}

const DURATIONS = [
  { days: 1, label: '1 день' },
  { days: 7, label: 'Неделя' },
  { days: 30, label: 'Месяц' },
];

/** Duration chips cut by confidancesMaxDuration (the API reports hours; the server checks days). */
export function confidanceDurations(maxHours: number | null) {
  if (!maxHours || maxHours <= 0) return DURATIONS;
  const maxDays = Math.floor(maxHours / 24);
  return DURATIONS.filter((d) => d.days <= maxDays);
}

export const CONFIDANCE_STATUS: Record<number, string> = { 1: 'Ждёт УК', 2: 'Активна', 3: 'Закрыта', 4: 'Начнётся' };

/** "79001234512" → "+7 900 123-45-12"; anything else as is. */
export function formatPhone(raw: string | null | undefined): string {
  const d = (raw ?? '').replace(/\D/g, '');
  const m = /^[78]?(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(d);
  return m ? `+7 ${m[1]} ${m[2]}-${m[3]}-${m[4]}` : raw ?? '';
}

/** tel: link for a phone written any way. */
export const telHref = (raw: string) => `tel:+${raw.replace(/\D/g, '').replace(/^8/, '7')}`;

/** «ИС» for the avatar when there is no photo. */
export const initials = (first?: string | null, last?: string | null): string => `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase() || '?';
